var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading d-flex flex-column justify-center align-center"},[_c('RiseLoader',{staticClass:"ring-loader",attrs:{"color":_vm.color,"loading":_vm.loading,"size":_vm.size,"sizeUnit":"px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }